import FontSizeMarkPlugin from './FontSizeMarkPlugin';

export default [FontSizeMarkPlugin];
